<template>
  <div class="avue-top">
    <div class="top-bar__left">
      <div
        class="avue-breadcrumb"
        :class="[{ 'avue-breadcrumb--active': isCollapse }]"
        v-if="showCollapse"
      >
        <i class="icon-navicon" @click="setCollapse"></i>
      </div>
    </div>
    <div class="top-bar__title">
      <div class="top-bar__item top-bar__item--show" v-if="showMenu">
        <top-menu></top-menu>
      </div>
    </div>
    <div class="top-bar__right">
      <el-tooltip
        v-if="showLock"
        effect="dark"
        content="锁屏"
        placement="bottom"
      ></el-tooltip>
      <div class="top-bar__item">
        <i></i>
        <span class="el-dropdown-link">
          {{ this.formatTime }}
        </span>
      </div>
      <el-tooltip
        v-if="showFullScren"
        effect="dark"
        :content="isFullScreen ? '退出全屏' : '全屏'"
        placement="bottom"
      >
        <div class="top-bar__item">
          <i
            :class="isFullScreen ? 'icon-zuixiaohua' : 'icon-quanpingzuidahua'"
            @click="handleScreen"
          ></i>
        </div>
      </el-tooltip>
      <el-dropdown>
        <span class="el-dropdown-link">
          切换系统
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in platformSelectList"
            :key="item.id"
            @click.native="() => handleSwitch(item.value)"
          >
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          {{ userInfo.username }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <router-link to="/">首页</router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link to="/info/index">个人信息</router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click="toEditPassword">修改密码</span>
          </el-dropdown-item>

          <el-dropdown-item @click.native="logout" divided>
            退出系统
          </el-dropdown-item>
          <el-dropdown-item @click.native="clearStorage" divided>
            清理缓存
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { fullscreenToggel, listenfullscreen } from '@/util/util';
import topMenu from './top-menu';
import { platform } from '@/api/admin/menu';
import { localPlatformKey } from '@/const/common';
import { isDev, isTest, isRelease } from '@/util/runtime';

export default {
  components: {
    topMenu,
  },
  name: 'top',
  data() {
    return {
      formatTime: '',
      intervalId: null,
      platformSelectList: [],
    };
  },
  filters: {},
  created() {
    this.getData();
    this.dataRefreh();
  },
  mounted() {
    listenfullscreen(this.setScreen);

    platform().then((res) => {
      this.platformSelectList = res.data.data.filter(
        (i) => i.value !== sessionStorage.getItem(localPlatformKey),
      );
    });
  },
  computed: {
    ...mapState({
      showLock: (state) => state.common.showLock,
      showFullScren: (state) => state.common.showFullScren,
      showCollapse: (state) => state.common.showCollapse,
      showMenu: (state) => state.common.showMenu,
    }),
    ...mapGetters([
      'userInfo',
      'isFullScreen',
      'tagWel',
      'tagList',
      'isCollapse',
      'tag',
      'logsLen',
      'logsFlag',
    ]),
  },
  methods: {
    toEditPassword() {
      window.location.href = '/m_op/editPassword/1783740821374054402';
    },

    // 清除缓存
    clearStorage() {
      localStorage.clear();
      sessionStorage.clear();
      this.$message.success('缓存清理成功');
      window.location.reload();
    },
    getUrl(path) {
      let suffix = '';
      let host = '';
      if (isTest) {
        suffix = '.qa';
        host = `https://dot-admin${suffix}.iol8.net`;
      } else if (isDev) {
        suffix = '.dev';
        host = `https://dot-admin${suffix}.iol8.net`;
      } else if(isRelease){
        host = `https://dot-admin.release.iol8.net`;
      } else {
        host = `https://dot-admin.woordee.com`;
      }
      const urls = {
        dot: `${host}/wel/index`,
        trm: `${host}/m_op/index`,
        bi: `${host}/m_op/index`,
        system: `${host}/wel/index`,
        saas: `${host}/m_op/index`,
        finance: `${host}/m_op/index`,
      };

      // @ts-ignore
      return urls[path] || `${host}/m_op/index`;
    },
    getData() {
      let d = new Date();
      let yy = d.getFullYear();
      let mm = d.getMonth() + 1;
      let dd = d.getDate();
      let hh = d.getHours();
      let mf = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
      let ss = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();

      let weeks = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ];
      let week = weeks[d.getDay()];

      this.formatTime =
        yy + '年' + mm + '月' + dd + '日  ' + hh + '点' + mf + '分 ' + week;
    },
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.getData(); //加载数据函数
      }, 1000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    handleScreen() {
      fullscreenToggel();
    },
    setCollapse() {
      this.$store.commit('SET_COLLAPSE');
    },
    setScreen() {
      this.$store.commit('SET_FULLSCREN');
    },
    handleSwitch(value) {
      sessionStorage.setItem(localPlatformKey, value);
      window.location.href = this.getUrl(value);
    },
    logout() {
      this.$confirm('是否退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push({ path: '/login' });
        });
      });
    },
  },
  destroyed() {
    // 在页面销毁后，清除计时器
    this.clear();
  },
};
</script>

<style lang="scss" scoped></style>
